import { Card } from '@/design-system';
import CemeteryIndex from './Cemetery/Index';
import GraveIndex from './Grave/Index';
import MunicipalityIndex from './Municipality/Index';

import { useParams } from 'react-router-dom';

const HomepageFindGraveThird = ({ municipalityName }) => {
  let { municipality, cemetery } = useParams();
  return (
    <div style={{ padding: '0px 12px', marginBottom: '24px' }}>
      <Card>
        {cemetery ? (
          <GraveIndex cemeterySlug={cemetery} />
        ) : municipality ? (
          <CemeteryIndex municipalitySlug={municipality} municipalityName={municipalityName} />
        ) : (
          <MunicipalityIndex />
        )}
      </Card>
    </div>
  );
};

export default HomepageFindGraveThird;
